import { type RootState } from "@/types/app";

export const selectBasketSlice = (state: RootState) => state.app.basket;
